export const LinkWhatsAppGST = (props: any) => {
    const link = props?.telefono ?  (/^[0-9]+$/g.test(props?.telefono) ?<a target="_blank" href={`https://wa.me/${props?.telefono}`}>
            {props?.label ? props?.label : props?.telefono}
        </a> : <>{props.telefono}</>) : <></>;

    return link
}
export default LinkWhatsAppGST